
'use client';
import { useState, useEffect } from 'react';
import { Card, CardContent} from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { enableAnalytics, disableAnalytics } from '@/lib/analytics';

const Privacy = () => {
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL;
  const privacyPolicyUrl = `${siteUrl}/policy.html`;
  useEffect(() => {
    const savedPreference = localStorage.getItem('analytics-enabled');
    if (savedPreference !== null) {
      setAnalyticsEnabled(JSON.parse(savedPreference));
    }
  }, []);

  const handleAnalyticsToggle = (enabled: boolean) => {
    setAnalyticsEnabled(enabled);
    localStorage.setItem('analytics-enabled', JSON.stringify(enabled));
    if (enabled) {
      enableAnalytics();
    } else {
      disableAnalytics();
    }
  };

  return (
    <div className="min-h-[80vh] bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-3 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
            Privacy
          </h1>
          <p className="text-gray-600">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <Card className="shadow-lg">
          <CardContent className="p-8 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-green-800 mb-3">Introduction</h2>
              <p className="text-gray-700 leading-relaxed">
                Welcome to Inspiriva Quotes. We are committed to protecting your privacy and ensuring
                you have a positive experience on our website. <a href={privacyPolicyUrl} target='_blank' className="text-green-600 hover:text-green-700 hover:underline">Click here</a> to view our full privacy policy.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-green-800 mb-3">Analytics Control</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  You have control over how we collect and use analytics data to improve our service.
                  You can enable or disable analytics tracking using the toggle below.
                </p>

                <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
                  <Switch
                    id="analytics-toggle"
                    checked={analyticsEnabled}
                    onCheckedChange={handleAnalyticsToggle}
                  />
                  <Label htmlFor="analytics-toggle" className="flex-1">
                    <span className="font-medium">Enable Analytics</span>
                    <p className="text-sm text-gray-600 mt-1">
                      {analyticsEnabled
                        ? "Analytics are currently enabled. We collect anonymous usage data to improve our service."
                        : "Analytics are currently disabled. No usage data will be collected."
                      }
                    </p>
                  </Label>
                </div>

                <p className="text-sm text-gray-600">
                  This preference is stored locally in your browser. Disabling analytics will prevent
                  the collection of usage data but will not affect the core functionality of the website.
                </p>
              </div>
            </section>

                        <section>
              <h2 className="text-xl font-semibold text-green-800 mb-3">Ads</h2>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  We rely on Google to serve ads on our website. Google may use cookies to serve ads based on your prior visits to our site or other sites on the internet. You can opt out of personalized advertising by visiting <a href="https://www.google.co.uk/settings/ads" target="_blank" className="text-green-600 hover:text-green-700 hover:underline">Google's Ads Settings</a>.
                </p>

              </div>
            </section>


          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
